<template>
  <modal
    id="availability"
    :is-open="openModal"
    @close="
      () => {
        $emit('close')
      }
    "
  >
    <transition name="fade" mode="out-in">
      <div key="form">
        <div class="row justify-content-center">
          <div class="col-12 title h3 text-center">{{ product.name }}</div>
          <div class="col-12 col-md-10 wysiwyg text-center">{{ $t("If you are interested in this product, please fill the form below and we'll contact you by email.") }}</div>
          <form class="form col-12 col-md-10" @submit.prevent="submit" novalidate>
            <fieldset :aria-describedby="subject && subject.comment ? 'reason-comment' : false">
              <base-select
                id="reason"
                name="reason"
                v-model="reason"
                :placeholder="$t('What the reason of your interest?') + ' *'"
                :options="subjects"
                :validations="[
                  {
                    condition: $v.reason.$error && !$v.reason.required,
                    text: $t('Field is required.'),
                  },
                ]"
                :required="true"
              />
              <transition name="fade">
                <p id="reason-comment" v-if="subject && subject.comment" v-text="subject.comment"></p>
              </transition>
            </fieldset>
            <transition name="fade">
              <div class="row" v-if="subject && subject.code == 53">
                <div class="col-6">
                  <base-input type="date" id="date" name="date" v-model.trim="date" :placeholder="$t('Date')" />
                </div>
                <div class="col-6">
                  <base-select
                    id="when"
                    name="when"
                    v-model="when"
                    :placeholder="$t('When')"
                    :options="[
                      { value: 'Morning', label: $t('Morning') },
                      { value: 'Noon', label: $t('Noon') },
                      { value: 'Afternoon', label: $t('Afternoon') },
                      { value: 'Evening', label: $t('Evening') },
                    ]"
                  />
                </div>
              </div>
            </transition>
            <base-textarea id="message" name="message" v-model="message" :placeholder="$t('Leave a message')" />
            <div class="form-heading">{{ $t('Personal information') }}</div>
            <base-select
              id="title"
              name="title"
              v-model="title"
              autocomplete="honorific-prefix"
              :placeholder="$t('Title') + ' *'"
              :validations="[
                {
                  condition: $v.title.$error && !$v.title.required,
                  text: $t('Field is required.'),
                },
              ]"
              :required="true"
              :options="[
                { value: 'mr', label: $t('Mr.') },
                { value: 'ms', label: $t('Mrs.') },
              ]"
            />

            <template v-if="countryCode === 'JP'">
              <base-input
              type="text"
              id="surname"
              :maxlength="MAX_LAST_NAME_LENGTH"
              name="surname"
              autocomplete="family-name"
              v-model="surname"
              @blur="$v.surname.$touch()"
              :placeholder="$t('Last name') + ' *'"
              :validations="[
                {
                  condition: !$v.surname.required && $v.surname.$error,
                  text: $t('Field is required.'),
                },
              ]"
              :required="true"
            />
              <base-input
              id="name"
              :maxlength="MAX_FIRST_NAME_LENGTH"
              type="text"
              name="name"
              autocomplete="given-name"
              v-model="name"
              @blur="$v.name.$touch()"
              :placeholder="$t('First name') + ' *'"
              :validations="[
                {
                  condition: !$v.name.required && $v.name.$error,
                  text: $t('Field is required.'),
                },
              ]"
              :required="true"
            />
              <base-input
                type="text"
                id="kanjiLastName"
                name="kanjiLastName"
                v-model="kanjiLastName"
                @blur="$v.kanjiLastName.$touch()"
                :placeholder="$t('Local last name')"
              />
              <base-input
                type="text"
                id="kanjiFirstName"
                name="kanjiFirstName"
                v-model="kanjiFirstName"
                @blur="$v.kanjiFirstName.$touch()"
                :placeholder="$t('Local first name')"
              />
            </template>
            <template v-else>
              <base-input
              id="name"
              :maxlength="MAX_FIRST_NAME_LENGTH"
              type="text"
              name="name"
              autocomplete="given-name"
              v-model="name"
              @blur="$v.name.$touch()"
              :placeholder="$t('First name') + ' *'"
              :validations="[
                {
                  condition: !$v.name.required && $v.name.$error,
                  text: $t('Field is required.'),
                },
              ]"
              :required="true"
            />
            <base-input
              type="text"
              id="surname"
              :maxlength="MAX_LAST_NAME_LENGTH"
              name="surname"
              autocomplete="family-name"
              v-model="surname"
              @blur="$v.surname.$touch()"
              :placeholder="$t('Last name') + ' *'"
              :validations="[
                {
                  condition: !$v.surname.required && $v.surname.$error,
                  text: $t('Field is required.'),
                },
              ]"
              :required="true"
            />
            </template>

            <base-input
              id="email"
              type="email"
              name="email"
              autocomplete="email"
              v-model="email"
              @blur="$v.email.$touch()"
              :placeholder="$t('E-mail address') + ' *'"
              :validations="[
                {
                  condition: !$v.email.required && $v.email.$error,
                  text: $t('Field is required.'),
                },
                {
                  condition: !$v.email.email && $v.email.$error,
                  text: $t('Please provide valid e-mail address.'),
                },
              ]"
              :required="true"
            />
            <base-phone
              id="phone"
              type="text"
              name="phone"
              autocomplete="tel-national"
              v-model="phone"
              :phoneIndic="phoneIndic"
              @phoneIndic="
                (v) => {
                  phoneIndic = v
                }
              "
              @blur="$v.phone.$touch()"
              :placeholder="$t('Phone N°') + ' *'"
              :validations="[
                {
                  condition: !$v.phone.required && $v.phone.$error,
                  text: $t('Field is required.'),
                },
                {
                  condition: $v.phoneIndic.$error && $v.phoneIndic.$error,
                  text: $t('Phone extension is required.'),
                },
              ]"
              :required="true"
            />
            <div class="toggle-line" :class="{ '-error': !$v.conditions.required && $v.conditions.$error }">
              <Toggle v-model="conditions" id="conditions" :required="true"></Toggle>
              <NoSSR>
                <label class="-small" for="conditions" v-html="$t('I accept the terms of use', { href: localizedUrl + '/page/terms' })">*</label>
              </NoSSR>
              <div class="form-error">
                <label for="conditions">{{ $t('Field is required.') }}</label>
              </div>
            </div>

            <NewsletterBox v-model="is_subscribed" />

            <div
              class="recaptcha"
              v-html="
                $t('This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.', {
                  hrefPrivacy: 'https://policies.google.com/privacy',
                  hrefTerms: 'https://policies.google.com/terms',
                })
              "
            ></div>
            <CustomLoader :is-loading="loading">
              <button class="btn -block" type="submit">{{ $t('Send') }}</button>
            </CustomLoader>
          </form>
        </div>
      </div>
    </transition>
  </modal>
</template>

<script>
import Modal from '../components/utils/Modal'
import Toggle from './form/Toggle'
import BasePhone from './form/BasePhone'
import BaseInput from '../components/form/BaseInput'
import BaseSelect from '../components/form/BaseSelect'
import BaseTextarea from '../components/form/BaseTextarea'
import NewsletterBox from '../components/form/NewsletterBox'
import { email, required, sameAs } from 'vuelidate/lib/validators'
import { ReadyHook } from 'vue-asyncready'
import NoSSR from 'src/themes/zenith/node_modules/vue-no-ssr'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { TaskQueue } from '@vue-storefront/core/lib/sync'
import config from 'config'
import { newsletter, MAX_FIRST_NAME_LENGTH, MAX_LAST_NAME_LENGTH, newsletterEventObject } from '../utilities'
import { mapActions, mapGetters } from 'vuex'
import CustomLoader from './utils/CustomLoader.vue'

export default {
  props: ['product', 'openModal'],
  name: 'ModalIconsForm',
  components: {
    Modal,
    BaseInput,
    BaseSelect,
    BasePhone,
    BaseTextarea,
    Toggle,
    NewsletterBox,
    NoSSR,
    CustomLoader
  },
  watch: {
    reason(newValue) {
      this.subject = this.subjects.find((x) => x.value == newValue)
    },
  },
  mixins: [ReadyHook],
  validations: {
    title: {
      required,
    },
    name: {
      required,
    },
    surname: {
      required,
    },
    phone: {
      required,
    },
    reason: {
      required,
    },
    phoneIndic: {
      required,
    },
    email: {
      required,
      email,
    },
    conditions: {
      sameAs: sameAs(() => true),
    },
  },
  data() {
    return {
      loading: false,
      success: false,
      title: '',
      name: '',
      reason: '',
      when: '',
      date: '',
      surname: '',
      kanjiFirstName: '',
      kanjiLastName: '',
      email: '',
      phone: '',
      message: '',
      phoneIndic: '',
      conditions: false,
      is_subscribed: false,
      subjects: [],
      subject: '',
      MAX_FIRST_NAME_LENGTH,
      MAX_LAST_NAME_LENGTH
    }
  },
  computed: {
    countryCode() {
      const { i18n } = currentStoreView()
      return i18n ? i18n.defaultCountry : 'XX'
    },
    localizedUrl() {
      return currentStoreView().url || ''
    },
    currentUser() {
      if (this.isLoggedIn) return this.$store.state.user.current
      else {
        return null
      }
    },
    currentView() {
      const { storeCode, i18n } = currentStoreView()
      const { fullCountryName, fullLanguageName } = i18n
      return {
        lang: fullLanguageName,
        country: fullCountryName,
        storeCode,
      }
    },
  },
  methods: {
    ...mapActions('feedback', ['show']),
    ...mapGetters('user', ['isLoggedIn']),
    getSubjectList() {
      TaskQueue.execute({
        url: config.api.url + '/api/ext/contact/list?type=icons',
        payload: {
          method: 'GET',
          mode: 'cors',
          headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
          },
        },
      }).then((res) => {
        this.subjects = res.result.items
          .map((item) => {
            return { value: item.entity_id, label: item.subject, code: item.code, comment: item.comment, checkInBoutique: item.checkInBoutique }
          })
          .filter(({ checkInBoutique }) => !(checkInBoutique && !this.product.in_boutique))
      })
    },
    async submit() {
      const formData = {
        civility: this.title,
        lastname: this.surname,
        firstname: this.name,
        kanjiFirstName: this.kanjiFirstName,
        kanjiLastName: this.kanjiLastName,
        country_id: this.countryCode,
        email: this.email,
        phone: this.phoneIndic + this.phone,
        subject: this.reason,
        message: this.message,
        product_id: this.product.id,
        appointment_date: this.date,
        appointment_when: this.when || '',
        retailer_code: this.product.in_boutique,
        user_id: this.currentUser ? this.currentUser.id : '',
        c_type: 'icons',
        locale: currentStoreView().storeCode
      }
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else {
        await this.$store.dispatch('googleRecaptcha/isVerifiedCaptcha')
        if (!this.$store.state.googleRecaptcha.is_verified) {
          this.show({ message: 'Recaptcha error. Please try again.', context: 'error' })
        } else {
          this.loading = true
          TaskQueue.execute({
            url: config.api.url + '/api/ext/contact/send',
            payload: {
              method: 'POST',
              mode: 'cors',
              headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            },
          })
            .then(() => {
              this.$emit('close')

              if (this.is_subscribed) {
                return newsletter({ email: formData.email, civility: formData.civility, firstname: formData.firstname, lastname: formData.lastname, kanjiFirstName: this.kanjiFirstName, kanjiLastName: this.kanjiLastName, country: this.currentView.country })
                  .then((response) => {
                    this.$gtm.trackEvent(newsletterEventObject({
                      siteLocation: 'PDP',
                      email: this.email
                    }))
                  })
                  .catch((error) => {
                    this.show({ message: 'Newsletter registration failed', context: 'error' })
                  })
              } else {
                return null
              }
            })
            .catch((error) => {
              this.show({ message: 'Notification registration failed', context: 'error' })
              console.log('Contact failed', error)
              this.loading = false
            })
        }
      }
    },
  },
  created() {
    this.getSubjectList()
  },
  mounted() {
    this.$v.$reset()
    if (this.currentUser) {
      this.title = this.currentUser.prefix || ''
      this.name = this.currentUser.lastname || ''
      this.surname = this.currentUser.firstname || ''
      this.email = this.currentUser.email || ''
      this.phone = this.currentUser.custom_attributes.filter((i) => i.attribute_code === 'phone').length ? this.currentUser.custom_attributes.filter((i) => i.attribute_code === 'phone')[0].value : ''
      this.is_subscribed = this.currentUser.extension_attributes.is_subscribed || false
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

.modal {
  .fade-enter,
  .fade-leave-to {
    position: static;
  }
}

.modal .content .row {
  margin: 0 -1rem !important;
}
.modal .content .title {
  margin-bottom: 2rem;
  color: var(--zenith-component-text);
}

.wysiwyg {
  margin-bottom: 4rem;
  color: var(--zenith-component-text);
}

.form {
  color: var(--zenith-component-text);
  .toggle-line {
    text-align: left;
  }
  p {
    margin-bottom: 2rem;
  }
}

.recaptcha {
  font-size: em(12);
  margin-bottom: 4rem;
  /deep/ a {
    color: var(--zenith-theme-primary);
    text-decoration: underline;
  }
}
</style>
